var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossIconVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 17.3179C19.1 17.7183 19.1 18.3189 18.7 18.7193C18.5 18.9194 18.3 19.0195 18 19.0195C17.7 19.0195 17.5 18.9194 17.3 18.7193L12 13.4141L6.7 18.7193C6.5 18.9194 6.3 19.0195 6 19.0195C5.7 19.0195 5.5 18.9194 5.3 18.7193C4.9 18.3189 4.9 17.7183 5.3 17.3179L10.6 12.0127L5.3 6.70752C4.9 6.30713 4.9 5.70654 5.3 5.30615C5.7 4.90576 6.3 4.90576 6.7 5.30615L12 10.6113L17.3 5.30615C17.7 4.90576 18.3 4.90576 18.7 5.30615C19.1 5.70654 19.1 6.30713 18.7 6.70752L13.4 12.0127L18.7 17.3179Z",
    fill: "#828282"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3948_65259",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 17.3179C19.1 17.7183 19.1 18.3189 18.7 18.7193C18.5 18.9194 18.3 19.0195 18 19.0195C17.7 19.0195 17.5 18.9194 17.3 18.7193L12 13.4141L6.7 18.7193C6.5 18.9194 6.3 19.0195 6 19.0195C5.7 19.0195 5.5 18.9194 5.3 18.7193C4.9 18.3189 4.9 17.7183 5.3 17.3179L10.6 12.0127L5.3 6.70752C4.9 6.30713 4.9 5.70654 5.3 5.30615C5.7 4.90576 6.3 4.90576 6.7 5.30615L12 10.6113L17.3 5.30615C17.7 4.90576 18.3 4.90576 18.7 5.30615C19.1 5.70654 19.1 6.30713 18.7 6.70752L13.4 12.0127L18.7 17.3179Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3948_65259)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H24V24.0235H0V0Z",
    fill: "#828282"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconVector);
export default __webpack_public_path__ + "static/media/CrossIconVector.73ce098df759cf7052efe28095ab0a51.svg";
export { ForwardRef as ReactComponent };